module.exports = __webpack_public_path__ + "img/template3.f3053e1b.png";